/**
 * State of the accounts module.
 */
export interface IAccountState {
    /**
     * Current sign up step.
     */
    step: number;

    /**
     * Whether or not Regily registration is currently open.
     */
    isRegilyOpen: boolean;

    /**
     * Whether or not user has requested account link
     */
    isAccountLinkRequested: boolean;

    /**
     * Whether the user has completed the bank account linking in current session
     */
    hasCompletedBankLinking: boolean;

    /**
     * Current deposit amount that user select in pay and play modal
     */
    depositAmount: number;

    /**
     * Selected welcome bonus code from pay and play modal
     */
    bonusCode: string;
}

export const ACCOUNT_NAMESPACE = 'account';

export const SET_SIGN_UP_STEP = 'SET_SIGN_UP_STEP';
export const SET_REGILY_OPEN_STATE = 'SET_REGILY_OPEN_STATE';
export const SET_ACCOUNT_LINK_REQUESTED = 'SET_ACCOUNT_LINK_REQUESTED';
export const SET_BANK_LINKING_COMPLETION = 'SET_BANK_LINKING_COMPLETION';
export const SET_DEPOSIT_AMOUNT = 'SET_DEPOSIT_AMOUNT';
export const SET_BONUS_CODE = 'SET_BONUS_CODE';
